import { render } from "./introduce.vue?vue&type=template&id=d760588c&scoped=true&ts=true"
import script from "./introduce.vue?vue&type=script&lang=ts"
export * from "./introduce.vue?vue&type=script&lang=ts"

import "./introduce.vue?vue&type=style&index=0&id=d760588c&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d760588c"]])

export default __exports__